module.exports = __webpack_public_path__ + "img/CI1.d0c82102.png";